import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import usePageMeta from "@/hooks/usePageMeta";
import { faqList } from "@/mocks/faq";

export default function Faq() {
  usePageMeta(
    "常见问题 · 小水看番泡面番推荐/三分钟短番",
    "关于泡面番、下饭番、摸鱼短番和短篇速刷的常见问题解答，帮你快速了解小水看番的推荐规则与使用方式。",
  );

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="bg-gradient-to-br from-accent-50 via-background-50 to-secondary-50 pt-24 pb-12">
          <div className="container-x text-center">
            <nav className="flex items-center justify-center gap-1.5 text-sm text-foreground-500" aria-label="面包屑">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-700">常见问题</span>
            </nav>
            <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              常见问题 FAQ
            </h1>
            <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              关于小水看番与泡面番推荐的常见疑问，这里都有答案。
            </p>
          </div>
        </section>

        <section className="container-x py-12 md:py-16">
          <div className="mx-auto max-w-3xl space-y-4">
            {faqList.map((item, idx) => (
              <div key={item.q} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <h2 className="flex items-start gap-3 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">
                    {idx + 1}
                  </span>
                  {item.q}
                </h2>
                <p className="mt-3 pl-10 leading-loose text-foreground-700">{item.a}</p>
              </div>
            ))}

            <div className="mt-6 rounded-2xl bg-primary-50 p-6 text-center">
              <h2 className="font-heading text-base font-bold text-foreground-950">还有疑问没解决？</h2>
              <p className="mt-2 text-sm text-foreground-600">欢迎随时通过邮件联系我们，小水会尽快回复你。</p>
              <a href="mailto:hello@xiaoshuikanfan.com" className="btn-pill mt-4 bg-primary-500 text-background-50 hover:bg-primary-600">
                <i className="ri-mail-line"></i> 联系我们
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}